
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `將其加入主屏幕，以獲得更豐富的體驗和便捷訪問。`,
's1b9047d53d9f9d22': `2) 點擊列表上的分享按鈕`,
's37a9e8aec5713460': `詳細資訊`,
's5c6aad7a7e4a1437': `3) 點擊加入主畫面`,
's6196153c4b0c1ea0': `安裝`,
's922329d6f6213590': `添加到Dock欄`,
'sa5ef80b4bb9b39f8': `簡短資訊`,
'sa7551383d1897fcc': `2) 點選添加到Dock欄`,
'sba52286c21552a4e': `在您的裝置上安裝它，以獲得更豐富的體驗和便捷訪問。`,
'sc79fd7641eb9a975': `隱藏安裝流程`,
'scdaf4bbff76674c8': `將App加入主畫面`,
'sdfe23506a3b0cdc8': `1) 在Safari上瀏覽此網頁`,
'se740f75b95a51807': `將其加入你的Dock欄，以獲得更豐富的體驗和便捷訪問。`,
'sfea652f6580ff086': `此網站具有應用程式功能。`,
    };
  